// extracted by mini-css-extract-plugin
export default {"iconoError":"UnitFormModal_iconoError__Jjxpq","notaTorre":"UnitFormModal_notaTorre__UNKDA ui_notaCampo12__pJohG"};